var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('form',{staticClass:"paymentSPG",attrs:{"spg-context":_vm.formContext,"spg-config":JSON.stringify(_vm.formConfig)}})])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }